<template>
  <div>
    <div
      class="home gundongtiao"
      v-bind:style="{ height: utils.setTableHeight(140) + 'px' }"
      style="overflow-y: auto; margin-left: -30px"
    >
      <my-menu :router="items" :treeData="items"></my-menu>
    </div>
    <Row type="flex" justify="end">
      <Col span="24">
        <div class="btn-wrap">
          <Button @click="cancel">取消操作</Button>
          <Button type="primary" @click="setRolePurview()">立即提交</Button>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import myMenu from "../../../node_modules/common/src/components/authorityMenu.vue";
import axios from "axios";
export default {
  props: ["roleId", "platformId", "scope"],
  name: "home",
  components: {
    myMenu,
  },
  data() {
    return {
      items: [],
      rolePurviewList: [],
    };
  },
  methods: {
    getMenu() {
      let params = {
        id: this.roleId,
        scope: this.scope,
      };
      console.log(params);
      axios({
        method: "post",
        url: axios.bm + "/role/authorities",

        data: params,
      }).then((res) => {
        var data = res.data.data;
        function setName(datas) {
          for (let i = 0; i < datas.length; i++) {
            datas[i].showHide = false;
            if (datas[i].childList.length > 0) {
              setName(datas[i].childList);
            }
          }
        }
        setName(data);
        this.items = data;
        //console.log("caidan", data);
      });
    },
    //设置权限
    setRolePurview() {
      this.rolePurviewList = [];
      this.setRoleList(this.items);
      let params = {
        id: this.roleId,
        resourceIdList: this.rolePurviewList,
        scope: this.scope,
      };
      axios({
        method: "post",
        url: axios.bm + "/role/authoritie",
        data: params,
      }).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.$emit("openRole", false);
        }
      });
    },
    //把角色放到参数里边准备传递
    setRoleList(datas) {
      for (let i = 0; i < datas.length; i++) {
        var obj = datas[i].id;
        if (datas[i].enabled == false) {
          continue;
        }
        this.rolePurviewList.push(obj);
        if (datas[i].childList.length > 0) {
          this.setRoleList(datas[i].childList);
        }
      }
    },
    cancel() {
      this.$emit("openRole", false);
    },
  },
  mounted() {
    this.getMenu();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/system/authority.vue